import { UrlObject } from 'url'
import { useRouter } from 'next/router'
import { useEffect } from 'react'

interface RedirectProps {
  to: UrlObject | string
  type?: 'push' | 'replace'
  /** For an address that names the same page, so a deep link keeps the element it was pointing at. */
  keepFragment?: boolean
}

export const Redirect: React.FC<RedirectProps> = ({ to, type = 'push', keepFragment = false }) => {
  const router = useRouter()
  const pushOrReplace = router[type]
  const fragment = router.asPath?.split('#')[1]
  const destination = keepFragment && fragment != null && typeof to === 'string' ? `${to}#${fragment}` : to

  useEffect(() => {
    void pushOrReplace(destination)
  }, [pushOrReplace, destination])

  return null
}
